<template>
  <div class="open-window-page">
    <div>OpenWindowPage</div>
    <el-button @click="open">open</el-button>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {
    async open() {
      this.$route.query.id = 123;
      const result = await this.$loaderWindow({
        component: () => import('./InnerWindow.vue'),
        props: { id: 'ABC' },
        title: '弹窗标题', width: '600px'
      });
      console.log('openWindow result:', result);
    }
  }
}
</script>

<style scoped>
.open-window-page {
  flex: 1;
  display: flex;
  flex-direction: column;
}
</style>
